<template>
  <div class="block py-24 sm:py-48" v-if="sellerCookie.Name && clubCookie.Name && isStartPage">
    <div class="container video-block mx-auto lg:flex xxl:px-24">
      <div class="video w-full bg-cover bg-center relative lg:h-320 lg:w-1/2 h-320 sm:h-410">
        <nuxt-img :src="clubCookie.Picture" sizes="mob375:100vw mob390:100vw mob414:100vw desk:655px"
          class="object-center object-cover absolute top-0 left-0 h-full w-full" :alt="clubCookie.Name" />
      </div>
      <div class="video-block__content w-full lg:w-1/2 py-40 md:p-56 lg:py-70 lg:px-128 xl:py-96">
        <div class="wysiwyg mx-auto">
          <h3>{{ $lang('header', 'sellerlink_welcome_header') }}</h3>
          <div class="mb-12">{{ $lang('header', 'sellerlink_welcome_text') }}</div>
          <div v-html="longClubtext" />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="sellerCookie.Name && clubCookie.Name" class="clubAndSeller
    bg-white text-black-full
    sticky top-0 flex justify-center items-center z-header-overlay mb-16 pt-8 pb-8
    border-b text-center" :style="topSticky">
    <span v-html="shortClubtext" />
  </div>
</template>

<script setup lang="ts">
import type { SellerClub, SellerPerson } from '~/constants/types/seller';
import { useUiStore } from '~/store/ui';
import { useConfigStore } from '~/store/config';
const uiStore = useUiStore();
const config = useConfigStore();
const clubCookie = useCookie<SellerClub>('club', { maxAge: 3600 * 24 * 182, path: '/' });
const sellerCookie = useCookie<SellerPerson>('seller', { maxAge: 3600 * 24 * 182, path: '/' });
console.log('cookie: ' + clubCookie.Name);
const showImage = ref(true);
const route = useRoute();
const { $lang } = useNuxtApp();

const isStartPage = computed<boolean>(()=> {
  const thisRoute = config.routeData(route.path);
  return (thisRoute?.is_startpage || route.path.indexOf('seller') > 0) || false;
});

const topSticky = computed(()=> {
  let top = 96;
  //if (clubCookie.Picture !== '' && isStartPage.value) {
  //  top -= uiStore.isMobile ? 258:172;
  //}

  return {
    'top': `${top}px`,
  };
});

const handleScroll = () => {
  showImage.value = window.scrollY < 174;
};

const longClubtext = computed(()=> {
  if (clubCookie && sellerCookie) {
    return $lang('header', 'club_site_message_long', {
      club: '<span class="font-medium">' + clubCookie.value.Name +'</span>',
      seller: '<span class="font-medium">' + sellerCookie.value.Name +'</span>',
    });
  } else {
    return '';
  }
});

const shortClubtext = computed(()=> {
  if (clubCookie && sellerCookie) {
    return $lang('header', 'club_site_message') + ' ' +
      '<span class="font-medium">' + clubCookie.value.Name  + '</span>. ' +
      $lang('seller', 'seller') + 
      ' <span class="font-medium">' + sellerCookie.value.Name  + '</span>'
  } else {
    return '';
  }
});

onMounted(()=> {
  //window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(()=> {
  //window.removeEventListener('scroll', handleScroll);
});

</script>

<style scoped lang="postcss">
</style>
